import Rollbar from "rollbar";

export function initRollbar(env: any, accessToken: any, commit_sha1: any) {
  (window as any).Rollbar = Rollbar.init({
    accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
        environment: env,
        code_version: commit_sha1,
        source_map_enabled: true,
    },
});
}

export function rollbarIdentifier(userEmail: any) {

  if ((window as any).Rollbar) {
    (window as any).Rollbar.configure({
    payload: {
        person: {
            id: userEmail,
            email: userEmail,
        },
    },
});
  }
}

export function reportError(message: any, err: any, level: 'error' | 'info' = 'error') {
  if ((window as any).Rollbar) {
    switch(level) {
      case 'info':
        (window as any).Rollbar.info(message, err);
        break;
      case 'error':
      default:
        (window as any).Rollbar.error(message, err);
        break;
    }
  }
}

